GatorSurvey.app.service("surveyResponseService", ['$http', SurveyResponseService]);

function SurveyResponseService($http) {
    var self = this;
    self.responses = [];
    self.responseId = "";
    self.updateCallbacks = [];
    self.updateNextSubmit = null;
    
    self.GetSurvey = function (id) {
        var isTest = "?t=0";
        if (typeof window.isTest !== "undefined") {
            isTest = "?t=" + window.isTest.toString();
        }
        return $http.get("api/survey/live/" + id + isTest).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };
    self.CompleteSurvey = function (version) {
        return $http.post("api/survey/response/completed/" + self.responseId +"/" + version).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };
    self.getAllResponses = function (id) {
        return $http.get("api/survey/response/" + self.responseId + "/all").then(function(response) {
            return response.data;
        }, function(response) {
            throw (response.data);
        });
    };
    self.BuildresponseModal = function (responseId, responses,pageId) {
        var responseModal = {
            id: responseId,
            pageid: null,
            responses: responses
        };
        if (typeof pageId != "undefined")
            responseModal.pageid = pageId;
        return $http.post('api/survey/response/add', responseModal).then(
            function (response) {
                return response.data;
            }, function (response) {
                throw (response.data);
            }
        );
    };
    self.AddUpdateResponse = function (id, response) {
        self.responses[id] = response;
    };
    self.updateAllResponces = function (reponses) {
        reponses.forEach(function (reponse) {
            if (typeof self.updateCallbacks[reponse.id] === "function") {
                self.updateCallbacks[reponse.id](reponse);
            }
        });
    };
    self.findResponce = function (id) {
        for (var i = 0; i < self.responses.length; i++) {
            var response = self.responses[i];
            if (response.id === id) {
                return response;
            }
        }
        return null;
    };
    self.AddNewQuestion = function (questionModel, updateCallBack) {
        var q = {};
        q.id = getUrlParameter("t") !== "1" ? questionModel.id : questionModel.tempId;
        q.type = questionModel.type;
        switch (questionModel.type) {
            case "checkbox":
                q.answers = [];
                break;
            case "grid":
                if (!questionModel.gridCheckbox) {
                    q.gridAnswers = [];
                    questionModel.grid.rows.forEach(function (item) {
                        q.gridAnswers.push({
                            id: getUrlParameter("t") !== "1" ? item.id : item.tempId,
                            selected: ""
                        });
                    });
                } else
                {
                    q.gridCheckAnswers = [];
                    questionModel.grid.rows.forEach(function (rowItem) {
                        var newGridCheck = {
                            id: getUrlParameter("t") !== "1" ? rowItem.id : rowItem.tempId,
                            checkBoxes: []
                        };
                        questionModel.grid.cols.forEach(function(colItem) {
                            newGridCheck.checkBoxes.push({
                                col: colItem.id,
                                value: false
                            });
                        });
                        q.gridCheckAnswers.push(newGridCheck);
                    });
                }
                break;
            case "priority":
                q.priorityAnswers = [];
                for (var i = 0; i < questionModel.priorityList.length; i++) {
                    var item = questionModel.priorityList[i];
                    q.priorityAnswers.push(
                    {
                        id: getUrlParameter("t") !== "1" ? item.id : item.tempId,
                        priority: i + 1
                    });
                }
                break;
            case "division":
                q.divisionAnswers = [];
                questionModel.divisionList.forEach(function (item) {
                    q.divisionAnswers.push({
                        id: getUrlParameter("t") !== "1" ? item.id : item.tempId,
                        value: 0
                    });
                });
                break;
            default:
                q.answer = "";
                break;
        }
        if (self.findResponce(q.id) === null) {
            self.responses.push(q);
            if (getUrlParameter("t") !== "1") {
                $http.get("api/survey/response/" + self.responseId + "/question/" + q.id + "/Get").then(
                    function(response) {
                        var responceData = response.data;
                        var re = self.findResponce(responceData.id);
                        for (var key in Object.keys(responceData)) {
                            key = Object.keys(responceData)[key];
                            if (re.hasOwnProperty(key)) {
                                re[key] = responceData[key];
                            }
                        }
                        updateCallBack(responceData);
                        self.updateCallbacks.push({ id: updateCallBack });
                    });
            } else {
                updateCallBack(self.findResponce(q.id));
            }
        } else {
            updateCallBack(self.findResponce(q.id));
        }
    };
    self.updateResponseQuestion = function (questionModel, newReponce, addtionalParam) {
        var questionId = getUrlParameter("t") !== "1" ? questionModel.id : questionModel.tempId;
        var savedResponce = self.findResponce(questionId);
        if (savedResponce !== null) {
            if (typeof savedResponce !== "undefined")
                switch (questionModel.type) {
                    case "checkbox":
                        if (!addtionalParam[1]) {
                            if (!newReponce) {
                                var index = savedResponce.answers.indexOf(addtionalParam[0]);
                                if (index > -1) {
                                    savedResponce.answers.splice(index, 1);
                                }
                            } else {
                                savedResponce.answers.push(addtionalParam[0]);
                            }
                        } else if (addtionalParam[1] === "isOther") {
                            if (!addtionalParam[0]) {
                                for (var si = 0; si < savedResponce.answers.length; si++) {
                                    if (savedResponce.answers[si].indexOf("IsOther:") > -1) {
                                        savedResponce.answers.splice(si,1);
                                    }
                                }
                            }
                             else {
                                savedResponce.answers.push("IsOther:" + (typeof questionModel.otherText === "undefined" || questionModel.otherText === null ? "" : questionModel.otherText));
                            }
                        } else if (addtionalParam[1] === "text") {
                            for (var ti = 0; ti < savedResponce.answers.length; ti++) {
                                if (savedResponce.answers[ti].indexOf("IsOther:") > -1) {
                                    savedResponce.answers[ti] = "IsOther:" + (typeof questionModel.otherText === "undefined" || questionModel.otherText === null ? "" : questionModel.otherText);
                                }
                            }
                        }

                        break;
                    case "radio":
                        if (!addtionalParam) {
                            savedResponce.answer = newReponce;
                        } else {
                            savedResponce.answer = "IsOther:"+newReponce;
                        }
                        break;
                    case "grid":
                        //put question Row ids in 
                        if (!questionModel.gridCheckbox) {
                            savedResponce.gridAnswers.forEach(function (item) {
                                if (item.id === addtionalParam[0]) {
                                    item.selected = newReponce;
                                }
                            });
                        } else {
                            savedResponce.gridCheckAnswers.forEach(function (item) {
                                var idToLookAt = getUrlParameter("t") !== "1" ? item.id : item.tempId;
                                if (idToLookAt === addtionalParam[0]) {
                                    item.checkBoxes.forEach(function(checkBoxItem) {
                                        if (checkBoxItem.col === addtionalParam[1]) {
                                            checkBoxItem.value = newReponce;
                                        }
                                    });
                                }
                            });
                        }
                        break;
                    case "priority":
                        for (var i = 0; i < newReponce.length; i++) {
                            var item = newReponce[i];
                            var foundPi = false;
                            for (var p = 0; p < savedResponce.priorityAnswers.length; p++) {
                                var priorityItem = savedResponce.priorityAnswers[p];
                                var idToLookAt = getUrlParameter("t") !== "1" ? priorityItem.id : priorityItem.tempId;
                                if (idToLookAt === item.id) {
                                    priorityItem.priority = i + 1;
                                    foundPi = true;
                                }
                            }
                            if (!foundPi) {
                                savedResponce.priorityAnswers.push({ id: item.id, value: i + 1 });
                            }
                        }
                        break;
                    case "division":
                        var found = false;
                        savedResponce.divisionAnswers.forEach(function (item) {
                            var idToLookAt = getUrlParameter("t") !== "1" ? item.id : item.tempId;
                            if (idToLookAt === addtionalParam) {
                                found = true;
                                item.value = newReponce;
                            }
                        });
                        if (!found) {
                            savedResponce.divisionAnswers.push({ id: addtionalParam, value: newReponce });
                        }
                        break;
                    default:
                        savedResponce.answer = newReponce;
                        break;
                }
        }
        if (typeof self.updateNextSubmit === "function") {
            self.updateNextSubmit();
        }
    };
    self.responseRequireCheck = function (id, questionType) {
        var savedResponce = self.findResponce(id);
        if (savedResponce !== null) {
            if (typeof savedResponce !== "undefined") {
                switch (questionType) {
                    case "checkbox":
                        return savedResponce.answers.length > 0;
                    case "grid":
                        //put question Row ids in 
                        var allComplete = true;
                        if (typeof  savedResponce.gridAnswers != "undefined")
                            savedResponce.gridAnswers.forEach(function(potenAns) {
                                if (potenAns.selected === null || potenAns.selected === "")
                                    allComplete = false;
                            });
                        else
                            savedResponce.gridCheckAnswers.forEach(function (potenAns) {
                                var rowHasSelected = false;
                                potenAns.checkBoxes.forEach(function(checkbox) {
                                    if (checkbox.value) {
                                        rowHasSelected = true;
                                    }
                                });
                                if (!rowHasSelected)
                                    allComplete = false;
                            });
                        return allComplete;
                    case "priority":
                        return true;
                    case "division":
                        var valCalc = 0;
                        savedResponce.divisionAnswers.forEach(function (potenAns) {
                            valCalc += potenAns.value;
                        });
                        return valCalc > 0;
                    default:
                        return savedResponce.answer !== null && savedResponce.answer !== "" && typeof savedResponce.answer !== "undefined";
                }
            }
        }
        return false;
    };
    self.retakeSurvey = function(responceId) {
        return $http.post("api/survey/response/" + responceId + "/retake").then(function(response) {
            return response.data;
        }, function(response) {
            throw (response.data);
        });
    };
    self.retakeHistory = function (responseId) {
        return $http.get("api/survey/response/retakeHistory/" + responseId).then(function (response) {
		    return response.data;
	    }, function (response) {
		    throw (response.data);
	    });
    };
}
